<template>
  <strong class="font-weight-bold d-block">
    <span v-if="normalPrice && !discountPrice && discountPrice !== 0">
      <span v-if="!isCurrencyForm">฿ </span>
      <span class="text__price">
        {{ formatPrice(normalPrice) }}
      </span>
      <span v-if="isCurrencyForm"> THB</span>
    </span>
    <span v-else-if="normalPrice === 0" class="text__price">FREE</span>

    <del
      v-else-if="normalPrice !== 0 && (discountPrice || discountPrice === 0) && isShowNormalPrice"
      style="opacity: 50%"
    >
      <span v-if="!isCurrencyForm">฿ </span>
      <span class="text__price">
        {{ formatPrice(normalPrice) }}
      </span>
      <span v-if="isCurrencyForm"> THB</span>
    </del>

    <span v-if="discountPrice && normalPrice" class="ml-3 text__discount-price">
      <span v-if="!isCurrencyForm">฿ </span>
      {{ formatPrice(discountPrice) }}
      <span v-if="isCurrencyForm"> THB</span>
    </span>
    <span v-else-if="discountPrice === 0 && normalPrice !== 0" class="ml-3 text__discount-price">
      FREE
    </span>
  </strong>
</template>

<script>
export default {
  props: {
    normalPrice: {
      type: Number,
      default: 0
    },
    discountPrice: {
      type: Number,
      default: 0
    },
    isCurrencyForm: {
      type: Boolean,
      default: false
    },
    isShowNormalPrice: {
      type: Boolean,
      default: true
    },
    isUppercase: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatPrice(number) {
      return Intl.NumberFormat('en-US', {
        currency: 'USD'
      }).format(number);
    }
  }
};
</script>

<style lang="scss" scoped></style>
